import { USER_DETAILS_FORM_FIELDS } from "repoV2/constants/user&auth&login/userDetails";
import { getLoggedInUserDetails } from "repoV2/utils/user&auth&login/loggedInUserDetails";

/**
 * Retrieves current customer details for payment payload.
 *
 * @returns {Object} - An object containing the current customer details suitable for a payment payload.
 */
export const getCustomerDetailsForPaymentPayload = () => {
    const loggedInUserDetails = getLoggedInUserDetails();
    return {
        [USER_DETAILS_FORM_FIELDS.full_name]:
            loggedInUserDetails.fullName || "",
        [USER_DETAILS_FORM_FIELDS.email]: loggedInUserDetails.email || "",
        [USER_DETAILS_FORM_FIELDS.phone]: loggedInUserDetails.phone || "",
        [USER_DETAILS_FORM_FIELDS.country]: loggedInUserDetails.country || "",
        [USER_DETAILS_FORM_FIELDS.country_code]:
            loggedInUserDetails.countryCode || "",
    };
};
